import React from "react";
import { useSelector } from "react-redux";
import { selectAppLoading } from "../redux/slices/appSettingsSlice";
import Injections from "./Injections";

const ConnectedInjections = () => {
    const appLoading = useSelector(selectAppLoading);

    return <Injections appLoading={appLoading} />;
};

export default ConnectedInjections;
